import styled from 'styled-components';
import { Typography } from 'antd';

export const EnhancedDropdownMenuWrapper = styled.div`
  & .ant-dropdown-menu .ant-dropdown-menu-item:hover,
  & .ant-dropdown-menu .ant-dropdown-menu-item-selected {
    font-weight: 600;
    background: ${({ theme }) => theme.colorPrimary};
    color: ${({ theme }) => theme.colorWhite};
  }

  & .ant-dropdown-menu .ant-dropdown-menu-item:not(.ant-dropdown-menu-item-selected):hover {
    opacity: 0.7;
  }
`;
export const EnhancedDropdownTitle = styled.a`
  display: flex;
  justify-content: space-between;
  line-height: 22px;
  min-width: 120px;
  color: ${({ theme }) => theme.colorTextDescription};

  &:hover {
    color: ${({ theme }) => theme.colorPrimary};
  }
`;

export const EnhancedDropdownPreviewSelected = styled(Typography.Text)`
  font-weight: 600;
  font-size: 22px;
  line-height: 28px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 28px;
`;
